import { PAY_URL, PAYMENT_SESSION_URL } from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';
import { PATH } from '../../constants/path';

export const validateMerchantSession = async url => {
    try {
        const response = await fetch(PAYMENT_SESSION_URL, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: HTTP_METHOD_POST,
            body: JSON.stringify({ url })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        return JSON.parse(res.payload);
    } catch (error) {
        console.error('Merchant session validation error:', error);
        throw error;
    }
};

export const authorizePayment = async (appleToken, userInfo, partnerId, orderId) => {
    try {
        const response = await fetch(
            `${PAY_URL}?email=${encodeURIComponent(userInfo.email)}${
                userInfo.userId ? `&userId=${userInfo.userId}` : ''
            }${userInfo.clickId ? `&clickId=${userInfo.clickId}` : ''}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method: HTTP_METHOD_POST,
                body: JSON.stringify({ appleToken, ...userInfo, partnerId, orderId })
            }
        );

        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}`;
        }

        const res = await response.json();
        return res.payload.widgetLink;
    } catch (error) {
        console.error('Merchant session validation error:', error);
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/services/applepay/utils.js